export type TechnicalSaleSubscriptionType = 'ELEVAGE' | 'STORE23' | 'CAE' | 'DEUXANS' | 'YEARLING' | 'ETALON' | 'PART_ETALON' | 'MIXTE'

export interface TechnicalSaleSubscription {
  id: number
  technicalSaleId: number
  startDate: string
  endDate: string
  type?: TechnicalSaleSubscriptionType
}

const technicalSaleSubscriptionTypes: { key: TechnicalSaleSubscriptionType, text: string, trot: boolean }[] = [
  {
    key: 'ELEVAGE',
    text: 'Elevage',
    trot: true,
  },
  {
    key: 'STORE23',
    text: 'Store 2 et 3',
    trot: false,
  },
  {
    key: 'CAE',
    text: 'CAE',
    trot: true,
  },
  {
    key: 'DEUXANS',
    text: '2 ans',
    trot: false,
  },
  {
    key: 'YEARLING',
    text: 'Yearling',
    trot: true,
  },
  {
    key: 'ETALON',
    text: 'Etalon et prospect stallion',
    trot: true,
  },
  {
    key: 'PART_ETALON',
    text: 'Part d\'étalon et breeding right',
    trot: true,
  },
  {
    key: 'MIXTE',
    text: 'Mixte',
    trot: true,
  },
]

export const mapTechnicalSaleSubscriptionTypes: Map<string, string> = new Map()
technicalSaleSubscriptionTypes.forEach((e) => {
  mapTechnicalSaleSubscriptionTypes.set(e.key, e.text)
})

export function getTechnicalSaleSubscriptionTypeLabel(key?: string): string | undefined {
  return mapTechnicalSaleSubscriptionTypes.get(key || '')
}

export const technicalSaleSubscriptionTypesGalop = technicalSaleSubscriptionTypes.sort((op1, op2) => op1.key.localeCompare(op2.key))
export const technicalSaleSubscriptionTypesTrot = technicalSaleSubscriptionTypes.filter(el => el.trot).sort((op1, op2) => op1.key.localeCompare(op2.key))
